module.exports = __webpack_public_path__ + "static/media/brice-and-text.020aba3c.svg";